import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthServiceProvider } from 'common';
import { map, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IsNotLoggedGuard implements CanActivate {

  constructor(private authServiceProvider: AuthServiceProvider,
              private router: Router) {
  }

  canActivate(_: ActivatedRouteSnapshot, _2: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.authServiceProvider.getService(false)
      .pipe(
        mergeMap(service => service.isLogged()),
        map(logged => {
          if (logged) {
            this.router.navigate(['/app']);
          }
          return !logged;
        }),
      );
  }

}
